<kendo-dialog-titlebar>
    {{'admin-center.user.selectRoleToAssign' | translate}}
</kendo-dialog-titlebar>

<form [formGroup]="assignRoleForm">

    <list-combo-select-ctrl [caption]="'admin-center.user.role'" [settings]="{fxFill:true}"
        [formControlName]="'roleId'" [textField]="'description'" [valueField]="'id'"
        [valuesList$]="rolesList$"></list-combo-select-ctrl>

</form>

<kendo-dialog-actions>
    <button  type="button" kendoButton (click)="confirm()" [primary]="true">{{'global.confirm' | translate}}</button>
</kendo-dialog-actions>